import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import React from "react";
import WebMain from "./pages/WebMain";
import { ThemeContextProvider } from "./theming";
import Paso1 from "./components/Paso1/Paso1";
import Resumen from "./components/Resumen/Resumen";
import VentaExitosa from "./components/Venta/VentaExitosa";
import VentaFracasada from "./components/Venta/VentaFracasada";
import NotFound from "./pages/NotFound"
import Error from "./pages/Error"
import { APIINTEGRACION } from "./helpers/url";
import Auth from "./components/Auth/Auth";
import Redirect from "./components/Redirect/Redirect";
import Caducada from "./pages/Caducada";


function App() {
  const [xml4, setXml4] = React.useState("");
  return (
    <ThemeContextProvider>
      <Router>
        <Routes>
          <Route exact path="auth/:rut" element={<WebMain headers={true} />}>
            <Route path="" element={<Auth />} />
          </Route>
          <Route exact path="web/bandeja" element={<WebMain headers={true} />}>
            <Route path="" element={<Paso1 />} />
            <Route path="resumen" element={<Resumen />} />
          </Route>
{/*       <Route exact path="redirect" element={<WebMain headers={true} />}>
            <Route path="" element={<Redirect />} />
          </Route>
           <Route exact path="web/ventaExitosa" element={<WebMain headers={true} />}>
            <Route path="" element={<VentaExitosa />} />
          </Route>
          <Route exact path="web/ventaFracasada" element={<WebMain headers={true} />}>
            <Route path="" element={<VentaFracasada />} />
          </Route> */}
          <Route exact path="redirect" element={<Redirect/>} />
          <Route exact path="web/ventaExitosa" element={<VentaExitosa  />} />
          <Route exact path="web/ventaFracasada" element={<VentaFracasada />} />
          <Route path="/error" element={<Error />} />
          <Route path="/sesion/caducada" element={<Caducada />} />
          <Route path="*" element={<NotFound />} />
       {/*  <Route exact path="/wordpress" element={<div>
        <label>Web:</label>

        <form target="_blank" action={APIINTEGRACION.GET.REDIRECT} method="get">
        <label for="r">Rut:</label><br></br>
        <input type="text" id="r" name="r" />
        <input type="number" id="w" name="w" hidden value={2}/>
        <input type="submit" value="Pagar" />
        </form>
        
        <label>Portal Cliente:</label>
        <form target="_blank" action={APIINTEGRACION.GET.REDIRECT} method="get">
        <label for="r">Rut:</label><br></br>
        <input type="text" id="r" name="r" />
        <input type="number" id="w" name="w" hidden value={1}/>
        <input type="submit" value="Pagar" />
        </form>

        <br></br>
        <label>Envío XML4:</label>
        <form target="_self" action={APIINTEGRACION.POST.CAMBIO_CONTEXTO+"?xml="+xml4} method="POST">
        <label for="xml">Xml4:</label><br></br>
        <textarea id="xml" name="xml" cols={50} value={xml4} onChange={(e)=>setXml4(e.target.value)}/>
        <input type="submit" value="Pagar" />
        </form>
      </div>} /> */}
        </Routes>
      </Router>
    </ThemeContextProvider>
  );
}

export default App;
